export default __webpack_public_path__ + "static/media/raspberryMuffin.fc67e99a.jpg";